const NATIONALITIES = {
  AU: { name: 'Australian', color: 'magenta' },
  BR: { name: 'Brazilian', color: 'red' },
  CA: { name: 'Canadian', color: 'volcano' },
  CH: { name: 'Swiss', color: 'orange' },
  DE: { name: 'German', color: 'gold' },
  DK: { name: 'Danish', color: 'lime' },
  ES: { name: 'Spanish', color: 'green' },
  FI: { name: 'Finnish', color: 'cyan' },
  FR: { name: 'French', color: 'blue' },
  GB: { name: 'British', color: 'geekblue' },
  IE: { name: 'Irish', color: 'purple' },
  IR: { name: 'Iranian', color: '#f50' },
  NO: { name: 'Norwegian', color: '#2db7f5' },
  NL: { name: 'Dutch', color: '#87d068' },
  NZ: { name: 'New Zealander', color: '#9e1068' },
  TR: { name: 'Turkish', color: '#ffd666' },
  US: { name: 'American' },
};

export default NATIONALITIES;
